import { RetryPlugin } from "@module-federation/retry-plugin";

const retryPlugin = () =>
  RetryPlugin({
    fetch: { retryTimes: 3, retryDelay: 1500 },
    script: {
      retryTimes: 3,
      retryDelay: 1500,
    },
  });
export default retryPlugin;
